import { BEATS, FRAMES_PER_BEAT } from './constants';
export class ArcadeTimer {
  frames = BEATS * FRAMES_PER_BEAT;
  get beats(): number { return Math.ceil(this.frames / FRAMES_PER_BEAT); }
  get ratio(): number { return this.frames / (BEATS * FRAMES_PER_BEAT); }
  reset(): void { this.frames = BEATS * FRAMES_PER_BEAT; }
  tick(): boolean { this.frames = Math.max(0, this.frames - 1); return this.frames === 0; }
}
